<template>
	<li class="nav-item navbar-dropdown dropdown-user dropdown">
		<a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
			<div class="avatar avatar">
				<span class="avatar-initial rounded-circle bg-label-secondary" style="font-size: 18px;">
					{{ currentFlag }}
				</span>
			</div>
		</a>
		<ul class="dropdown-menu dropdown-menu-end">
			<li v-for="lang in languages" :key="lang.code">
				<a class="dropdown-item" :class="{ active: $i18n.locale === lang.code }" href="javascript:void(0);" @click="switchLanguage(lang.code)">
					<span style="font-size: 18px; margin-right: 8px;">{{ lang.flag }}</span>
					{{ lang.label }}
				</a>
			</li>
		</ul>
	</li>
</template>

<script>
import moment from "moment";

export default {
	name: "LanguageSwitcher",

	data() {
		return {
			languages: [
				{ code: "fr", label: "Français", flag: "🇫🇷" },
				{ code: "en", label: "English", flag: "🇬🇧" },
				{ code: "es", label: "Español", flag: "🇪🇸" }
			]
		};
	},

	computed: {
		currentFlag() {
			const lang = this.languages.find(l => l.code === this.$i18n.locale);
			return lang ? lang.flag : "🇫🇷";
		}
	},

	methods: {
		switchLanguage(locale) {
			this.$i18n.locale = locale;
			localStorage.setItem("locale", locale);
			document.documentElement.setAttribute("lang", locale);
			moment.locale(locale);
		}
	}
};
</script>
